import l10n = require('diy/util/l10n');
import {showDialog as showAviaryShutDownDialog} from 'diy/aviary/DiyAviaryShutdownDialog';

import Type from '../definitions/Type';
import {NotificationConfig} from '../definitions/Config';

export default {
    type: Type.AVIARY_SHUTDOWN,

    testId: 'aviary-shutdown',
    trackingId: 'AviaryShutdownNotification',

    content: l10n.getString('aviaryDialog.shutdown.notification.content'),

    mainAction: {
        testId: 'aviary-shutdown-open-notice',
        label: l10n.getString('aviaryDialog.shutdown.notification.more'),
        onClick: () => {
            showAviaryShutDownDialog();
        }
    }

} as NotificationConfig;



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/toolbar/notificationNG/types/AviaryShutdown.ts
 **/